import { Employee_Api_EndPoints } from "../global/end-points";

const PrivilegeService = {
    async fetchPrivileges(phoneNumber, webModule, privilege) {
        const params = new URLSearchParams({
            phoneNumber,
            webModule,
        });
        if (privilege) {
            params.append('privilege', privilege);
        }
        const url = `${Employee_Api_EndPoints.GET_PRIVILEGES}?${params.toString()}`;
        const response = await fetch(url);
        if (!response.ok) throw new Error('Failed to fetch privileges');
        const data = await response.json();

        // Store the full response object in sessionStorage
        sessionStorage.setItem("Privileges", JSON.stringify(data));

        // 🔔 Tell the app privileges are ready (makes Header re-render now, no refresh needed)
        window.dispatchEvent(new Event("privileges-updated"));

        return data;
    },

    hasReadAccess(privilegesObj, moduleName) {
        if (!privilegesObj || !Array.isArray(privilegesObj.privileges)) return false;
        return privilegesObj.privileges.some(
            (p) => p.moduleName === moduleName && p.canRead
        );
    }
};

export default PrivilegeService;